// hooks/useFetch.js
import { useState, useEffect, useCallback } from 'react';
import { fetchWithAuth } from 'utils/auth';

const useFetch = (endpoint, options = {}, dependencies = []) => {
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchData = useCallback(async (controller) => {
    setIsLoading(true);
    setError(null);
    try{
      const url = `${process.env.REACT_APP_SERVER_URL}/${endpoint.replace(/^\/+/, '')}`;
      const resp = await fetchWithAuth(url, { ...options, signal: controller.signal });

      if(!resp.ok){
        const txt = await resp.text();
        throw new Error(`HTTP ${resp.status}: ${txt}`);
      }
      const result = await resp.json();
      setData(result);
    }catch(err){
      if(err.name !== 'AbortError'){
        setError(err.message);
      }
    }finally{
      setIsLoading(false);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [endpoint, JSON.stringify(options)]);

  useEffect(() => {
    const controller = new AbortController();
    fetchData(controller);
    return () => controller.abort();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, dependencies);

  return { data, isLoading, error, refetch: () => fetchData(new AbortController()) };
};

export default useFetch;
